import xlsx from "xlsx";


export function saveJsonToExcel(json, fileName = "test.xlsx", options = {}) {
  const wb = xlsx.utils.book_new();
  const ws = xlsx.utils.json_to_sheet(json, options);
  xlsx.utils.book_append_sheet(wb, ws, "SheetJS");
  xlsx.writeFile(wb, fileName);
}